import { render, staticRenderFns } from "./carta.vue?vue&type=template&id=7917d674&"
import script from "./carta.vue?vue&type=script&lang=js&"
export * from "./carta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports